import { ButtonProps } from '@app/types'

import { StyledButton } from './elements'

export const Button: React.FC<ButtonProps> = (props) => <StyledButton {...props} />
